import classes from '@src/styles/SustainabilityFeatures.module.css'
import simple from '@src/assets/sustainability/simple.jpg'
import seamless from '@src/assets/sustainability/seamless.jpg'
import sustainable from '@src/assets/sustainability/sustainable.jpg'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import openKustomer from '@src/functions/kustomer'

function SustainabilityFeatures() {
  const router = useRouter();
  const { gclid, keyword, location } = router.query;
  return (
    <section className={classes.container}>
      <div className={classes.mainContent}>
        <div className={classes.featureContainer}>
          <div className={classes.feature}>
            <Image src={simple} alt='Simple' />
            <h4 className={classes.featureHeader}>Simple</h4>
            <p className={classes.description}>
              Dimension makes it easy and convenient for your business to minimize its environmental
              impact.
            </p>
          </div>
          <div className={classes.feature}>
            <Image src={seamless} alt='Seamless' />
            <h4 className={classes.featureHeader}>Seamless</h4>
            <p className={classes.description}>
              Our all-in-one digital platform allows you to effortlessly integrate eco-friendly
              waste management into your workflow.
            </p>
          </div>
          <div className={classes.feature}>
            <Image src={sustainable} alt='Sustainable' />
            <h4 className={classes.featureHeader}>Sustainable</h4>
            <p className={classes.description}>
              We&apos;re here to help you donate, recycle and dispose of unwanted items sustainably,
              without any additional stress or hassle.
            </p>
          </div>
        </div>
        <div className={classes.buttonContainer}>
          <Link href={`${process.env.NEXT_PUBLIC_REDIRECT_URL}booking?step=initial&gclid=${gclid}&keyword=${keyword ?? ""}&redirect=1&location=${location}`} className={classes.primaryButton}>
            Book Now
          </Link>
          <button className={classes.secondaryButtonDark} onClick={openKustomer}>
            <p>Chat With Us</p>
          </button>
        </div>
      </div>
    </section>
  )
}

export default SustainabilityFeatures
